import NewsLetterIcon from "@/components/icons/NewsLetterIcon";
import Spinner from "@/components/icons/Spinner";
import toast from "react-hot-toast";

import { getCookies } from "cookies-next";
import { useTranslation } from "next-i18next";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { subscribeToNewsletter } from "@/services/newsletter";
import { EmailValidation } from "@/utils/valitation/subscribe";
import { news_letter_subscribed } from "@/utils/gtm";

const NewsLetter = () => {
  const { t } = useTranslation("common");
  const { handshake, mage } = getCookies();

  return (
    <section className="py-1.5 sm:py-4 bg-primary">
      <div className="flex flex-col items-center justify-between w-11/12 gap-4 py-4 mx-auto md:flex-row">
        <div className="flex gap-4 text-white">
          <NewsLetterIcon className="max-sm:h-10 max-sm:w-16" />
          <div className="flex flex-col justify-center gap-2">
            <p className="text-sm font-bold lg:text-xl">
              {t("Sign Up For Newsletter")}
            </p>
            <p className="text-xs lg:text-base">
              {t("news_letter_description")}
            </p>
          </div>
        </div>
        <Formik
          validationSchema={EmailValidation(t)}
          initialValues={{ email: "" }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            console.log("values", values.email);
            const res = await subscribeToNewsletter(
              handshake,
              mage,
              values.email
            );
            if (res.status == 200) {
              !res.data.data.at(0).error
                ? toast.success(res.data.data.at(0).message)
                : toast.error(res.data.data.at(0).message);
              news_letter_subscribed(values.email);
            } else {
              toast.error(res.error.error.at(0).message);
            }
            console.log(res);

            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting }) => (
            <Form className="relative flex-1 w-full text-xs md:flex-initial md:w-80 lg:text-base">
              <div className="flex items-center">
                <Field
                  name="email"
                  placeholder={t("Enter Your Email")}
                  className="w-full p-1.5 py-2 max-sm:py-2.5 max-sm:placeholder:text-xs  bg-white border border-white outline-none"
                />
                <button
                  disabled={isSubmitting}
                  aria-label="Subscribe Button"
                  // className="flex gap-2 px-6 py-2 text-white bg-pink-900 border border-pink-900 max-sm:text-sm md:px-4"
                  className="flex gap-2 px-6 py-2 text-white bg-[#00343a]/40 border border-white max-sm:text-sm md:px-4"
                >
                  {isSubmitting && <Spinner width={18} />} {t("Subscribe")}
                </button>
              </div>
              <ErrorMessage
                name="email"
                component="div"
                className="text-xs text-warning sm:text-sm"
              />
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default NewsLetter;
